import type { BillHistory } from "../api/reportsBillsHistory";

/**
 * Изцяло сторнирана сметка („Сторнирай всичко" или ред по ред до последния):
 * остава закрита, но продажба няма — фактура към нея няма какво да носи.
 * BE я отказва (409, `InvoiceService._ensure_bills_exist_and_free`), FE не я
 * предлага в двата избора и „Фактуриране" стои сив.
 *
 * Същото правило като в BE: има сторнирани редове и нито един жив — по
 * `statistics`, които BE брои извън копията-следи от разделяне. Сметка без
 * никакви редове не е сторно (и не се пипа тук).
 */
export const isFullyCancelledBill = (bill: Pick<BillHistory, "statistics">): boolean =>
  (bill.statistics?.cancelled_items ?? 0) > 0 && (bill.statistics?.active_items ?? 0) === 0;
